export default __webpack_public_path__ + "static/media/distractions2.909a88e3.png";